<template>
  <div class="special_detail_container">
    <!-- indexMode 1普通模式 2飞卡模式 -->
    <!-- classfyStyleMode 1tab 2锚点 -->
    <template001
      :detail="detail"
      :contentId="contentId"
      :deviceId="deviceId"
      v-if="
        !!contentId &&
        !!detail &&
        detail.indexMode == 1 &&
        detail.classfyStyleMode == 1
      "
    ></template001>
    <template002
      :detail="detail"
      :contentId="contentId"
      :deviceId="deviceId"
      v-else-if="
        !!contentId &&
        !!detail &&
        detail.indexMode == 1 &&
        detail.classfyStyleMode == 2
      "
    ></template002>
    <template003
      :detail="detail"
      :contentId="contentId"
      :deviceId="deviceId"
      :infoKey="infoKey"
      v-else-if="!!contentId && !!detail && detail.indexMode == 2"
    ></template003>
  </div>
</template>
<script>
import { mapState } from "vuex";
import {
  getRandomStr32,
  loadStat,
  clickPlayCount,
  addH5Escalate,
} from "@/utils";
import specialApi from "@/api/apis/special.js";
import commApi from "@/api/apis/common.js";
import template001 from "./components/template001";
import template002 from "./components/template002";
import template003 from "./components/template003";
import isJumpJs from "@/components/mixins/isJump.js";
import md5 from "js-md5";
import newsApi from "@/api/apis/news.js";
import { formatUTCDateTime } from "@/utils";
export default {
  name: "SpecialDetail",
  mixins: [isJumpJs],
  components: {
    template001,
    template002,
    template003,
  },
  data() {
    return {
      /* 设备Id */
      deviceId: null,
      contentId: null,
      detail: null,
      shareUrl: "",
      infoKey: "",
    };
  },
  computed: {
    ...mapState("app", ["userInfo", "nodeCode"]),
  },
  methods: {
    /* 微信二次分享 */
    wechatShare() {
      var _this = this;

      commApi
        .getWeiXinTicket({
          nodeCode: _this.nodeCode,
          url: _this.shareUrl,
        })
        .then((res) => {
          var shareImgurl = "";
          if (!!_this.detail.imgUrl && _this.detail.imgUrl.length > 0) {
            shareImgurl = _this.detail.imgUrl;
          } else if (
            !!_this.detail.bigResouceUrl &&
            _this.detail.bigResouceUrl.length > 0
          ) {
            shareImgurl = _this.detail.bigResouceUrl;
          }
          var desc =
            _this.detail.summaryStatus && _this.detail.summarySth
              ? _this.detail.summarySth
              : _this.detail.introduction;
          _this.$WeiXin.shareWeiXin(
            res,
            "专题\xa0|\xa0" + _this.detail.specialTitle,
            desc,
            _this.shareUrl,
            shareImgurl
          );
          this.$emit("initWeiXinTicket")
        })
        .catch((err) => {});
    },
    /* 获取专题 */
    getSpecialContentById() {
      var _this = this;
      var params = { contentId: _this.contentId };

      specialApi
        .getSpecialContentById(params)
        .then((res) => {
          if (res.suc == 1) {
            document.title = res.data.specialTitle;
            _this.detail = res.data;
            // 中宣部埋点：稿件详情页浏览
            _this.$track.trackArticleDetailPV(
              _this.$track.mapArticleProps(_this.detail, {
                pageName: "专题详情页",
                pageId: "special_detail",
                extra: {
                  article_type: "专题",
                  article_name: res.data.specialTitle || "",
                  special_topic_name: res.data.specialTitle || "",
                },
              })
            );
            _this.wechatShare(); // 微信二次分享
            _this.statistics(); // 统计
          }
        })
        .catch((err) => {
          // _this.$toast({
          //   message: "接口调用出错",
          //   position: "center",
          // });
        });
    },
    async getPreviewDetail(infoKey) {
      try {
        const paramsDto = {
          infoKey,
        };
        const res = await newsApi.getNewsInfo(JSON.stringify(paramsDto));
        if (res.suc == 1) {
          const info = res.data?.materialInfo || {};
          info.creationTime = formatUTCDateTime(info.creationTime);
          info.firstAppPublishTime = formatUTCDateTime(
            info.firstAppPublishTime
          );
          document.title = res.data.materialInfo.title;
          this.detail = {
            ...info,
            ...res.data,
          };
          if (!this.detail.specialTitle) {
            this.detail.specialTitle = this.detail.title;
          }
        } else {
          this.detail = null;
          this.$toast({
            message: res.message ||"接口调用出错",
            position: "center",
          });        }
      } catch (err) {
        this.detail = null;
        this.$toast({
            message: err.message ||"接口调用出错",
            position: "center",
          });;
      }
    },
    /* 统计 */
    statistics() {
      let tj_params = {
        contentCreationTime: this.detail.contentCreationTime, // 创建时间
        contentId: this.detail.id, // 专题Id
        contentTitle: this.detail.specialTitle,
        contentType: 7,
        memberId: this.detail.memberId, // 当前稿件的编辑者的id
        nickName: this.detail.nickName, // 当前稿件的编辑者的用户名称
      };
      if (!!this.detail.channelId && this.detail.channelId > 0) {
        tj_params = Object.assign(tj_params, {
          channelId: this.detail.channelId, // 栏目id
          channelName: this.detail.channelName, // 栏目名称
        });
      }
      if (this.relayParams && this.relayParams.uik) {
        tj_params.uik = this.relayParams.uik;
        tj_params.share_plat = this.relayParams.share_plat;
        let sec = md5(
          tj_params.uik +
            this.detail.id +
            tj_params.contentType +
            tj_params.share_plat
        );
        sec = sec.substring(0, 8);
        tj_params.sec = sec;
      }
      clickPlayCount(tj_params);
      addH5Escalate();
    },
  },
  created() {
    let query = this.$route.query;
    if (Object.prototype.hasOwnProperty.call(query, "contentId")) {
      this.contentId = Number(query.contentId);
      if (this.contentId == 1405372) {
        query.contentId = 1405597;
        query.contentType = "column";
        this.$router.replace({
          path: "/column_detail",
          query: query,
        });
      } else if (this.contentId == 1405597) {
        query.contentType = "column";
        this.$router.replace({
          path: "/column_detail",
          query: query,
        });
      } else {
        if (!this.userInfo) {
          this.deviceId = getRandomStr32();
        }
        if (query.infoKey) {
          this.infoKey = query.infoKey;
          this.getPreviewDetail(query.infoKey);
        } else {
          this.getSpecialContentById(); //获取专题
          loadStat(); // 友盟统计
        }
      }
    } else {
      this.$router.replace({
        path: "/error",
      });
    }
  },
};
</script>
<style scoped lang="scss">
.special_detail_container {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
</style>
